import request from '../../utils/RequestManager';

import config from '../../config';

const baseURL = config.AUTH_HOST;

export function getAvailableTariffs(cancelToken = null) {
  return request({
    method: 'GET',
    baseURL,
    url: '/tariffs/packages',
    cancelToken,
  }).then(res => res.data);
}



// WEBPACK FOOTER //
// ./src/components/tariff/api.js